var React = require('react');

function Moon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{opacity:0;}")),React.createElement("rect",{"className":"a","width":"24","height":"24","key":1}),React.createElement("path",{"d":"M12.3,22h-.1a10.31,10.31,0,0,1-7.34-3.15,10.46,10.46,0,0,1-.26-14,10.13,10.13,0,0,1,4-2.74A.985.985,0,0,1,9.9,3.33a8.4,8.4,0,0,0,1.94,8.81,8.47,8.47,0,0,0,8.83,1.94,1,1,0,0,1,1.27,1.29A10.16,10.16,0,0,1,19.6,19a10.28,10.28,0,0,1-7.3,3ZM7.46,4.92A7.93,7.93,0,0,0,6.09,6.14a8.44,8.44,0,0,0,.2,11.32A8.29,8.29,0,0,0,12.22,20h.08a8.34,8.34,0,0,0,6.78-3.49A10.37,10.37,0,0,1,7.46,4.92Z","key":2})]);
}

Moon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Moon;

Moon.default = Moon;
